module.exports = __webpack_public_path__ + "static/media/sadhanabolla.58698272.png";